import { i18n, required, regex, email, alphanum, maxLength } from "@isocial-vue/blueprint";

const VALIDATION = {
  email: email("rtwp.form.error.email"),
  required: required("rtwp.form.error.required"),
  alphanumericRequired: (v: string) => !!(v || "").toString() || i18n.t("rtwp.form.error.required"),
  alphanumeric: alphanum("rtwp.form.error.alphanumeric"),
  onss: regex(/^[0-9]{8,10}$/, "rtwp.form.error.onss"),
  maxChar: (max: number) => maxLength(max, "rtwp.form.error.max"),
  cbe: (v: string) => {
    if (!v) return i18n.tc("format.bce.error");
    const match = v.match(/^[01]?[0-9]{9}$/);
    return match ? true : i18n.tc("format.bce.error");
  },
  phone: (v: string) => {
    const val = v?.replaceAll(/[ +./()]/g, "");
    const regex = /^[0-9]{7,15}$/g;
    return (val && regex.test(val)) || i18n.t("rtwp.form.error.phone");
  },
};

// const INPUTS = {
//   word: (v: string) => (!v ? v : v?.replaceAll(/[^A-Za-z]/gi, "")),
//   digit: (v: string) => (!v ? v : v?.replaceAll(/\D/gi, "")),
//   worddigit: (v: string) => (!v ? v : v?.replaceAll(/\W/gi, "")),
// };

const KEYS = {
  words: {
    allowed: /[A-Za-z]/g,
    forbidden: /[^A-Za-z]/g
  },
  digits: {
    allowed: /[0-9]/g,
    forbidden: /[^0-9]/g
  },
  wordDigits: {
    allowed: /[A-Za-z0-9]/g,
    forbidden: /[^A-Za-z0-9]/g,
  }
};

export const form = [
  { id: "demand" },
  {
    id: "company",
    groups: [
      {
        id: "info",
        fields: [
          {
            id: "companyName",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
            keep: true,
            onInput: (v: string) => {
              if (!v) return v;
              return v.length > 10 ? v.slice(0, 50) : v;
            },
          },
          {
            type: "spacer",
            col: { cols: 12, md: 4 },
          },
          {
            id: "street",
            col: { cols: 12, md: 8 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
            keep: true,
          },
          {
            id: "houseNumber",
            col: { cols: 12, md: 2 },
            rules: [VALIDATION.alphanumericRequired, VALIDATION.alphanumeric, VALIDATION.maxChar(10)],
            required: true,
            keep: true,
          },
          {
            id: "boxNumber",
            col: { cols: 12, md: 2 },
            rules: [VALIDATION.alphanumeric, VALIDATION.maxChar(10)],
            keep: true,
          },
          {
            id: "province",
            col: { cols: 12, md: 3 },
            rules: [VALIDATION.maxChar(50)],
            keep: true,
            condition: {
              field: "company.info.country",
              value: "be",
              diff: true,
              notFlex: true
            },
          },
          {
            id: "zipCode",
            col: { cols: 12, md: 3 },
            rules: [VALIDATION.alphanumericRequired, VALIDATION.alphanumeric, VALIDATION.maxChar(10)],
            required: true,
            keep: true,
          },
          {
            id: "municipality",
            col: { cols: 12, md: 3 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
            keep: true,
          },
          {
            id: "country",
            type: "country",
            col: { cols: 12, md: 3 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
            keep: true,
            initialValue: 'be'
          },
          {
            id: "CBENumber",
            col: { cols: 12, md: 4 },
            readOnlyBE: true,
            rules: [VALIDATION.required, VALIDATION.cbe],
            required: true,
            // rulesBE: [VALIDATION.required, VALIDATION.cbe],
            // requiredBE: true,
            templatesBE: [],
            templates: ["bce"],
            keep: true,
            keys: KEYS.digits,
            tooltip: true,
            condition: {
              field: "company.info.country",
              value: "be",
            },
            // onInput: INPUTS.digit,
          },
          {
            id: "ONSSNumber",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.onss],
            // rules: [VALIDATION.required, VALIDATION.onss],
            required: true,
            keep: true,
            keys: KEYS.digits,
            tooltip: true,
            condition: {
              field: "company.info.country",
              value: "be",
            },
            // onInput: INPUTS.digit,
          },
          {
            type: "spacer",
            col: { cols: 12, md: 4 },
          },
          {
            id: "iban",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            templates: ["iban"],
            keep: true,
            tooltip: true
          },
          {
            id: "bic",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.alphanumericRequired],
            required: true,
            templates: ["bic"],
            keep: true,
            keys: KEYS.wordDigits,
            // onInput: INPUTS.worddigit,
          },
          {
            id: "hasEbox",
            type: "checkbox",
            initialValue: false,
            col: { cols: 12 },
            keep: true,
          },
        ],
      },
      {
        id: "contact",
        fields: [
          {
            id: "lastName",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
            keep: true,
          },
          {
            id: "firstName",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.maxChar(50), VALIDATION.maxChar(50)],
            keep: true,
          },
          {
            type: "spacer",
            col: { cols: 12, md: 4 },
          },
          {
            id: "phone",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.phone],
            required: true,
            keep: true,
          },
          {
            id: "email",
            type: "email",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.email, VALIDATION.maxChar(100)],
            required: true,
            keep: true,
          },
        ],
      },
    ],
  },
  {
    id: "worker",
    groups: [
      {
        id: "info",
        fields: [
          {
            id: "ssin",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            templates: ["ssin"],
            keys: KEYS.digits,
            tooltip: true
            // onInput: INPUTS.digit,
          },
          {
            type: "spacer",
            col: { cols: 12, md: 8 },
          },
          {
            id: "lastName",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
          },
          {
            id: "firstName",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required, VALIDATION.maxChar(50)],
            required: true,
          },
        ],
      },
      {
        id: "professionalSituation",
        fields: [
          {
            id: "employmentContract",
            type: "select",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            options: [{ value: "employee" }, { value: "selfEmployed" }, { value: "other" }],
          },
          {
            type: "spacer",
            col: { cols: 12, md: 8 },
          },
          {
            id: "contractDuration",
            type: "select",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            options: [{ value: "openEnded" }, { value: "fixedTerm" }],
          },
          {
            id: "contractEndDate",
            type: "date",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            condition: {
              field: "worker.professionalSituation.contractDuration",
              value: "fixedTerm",
            },
          },
          {
            type: "spacer",
            col: { cols: 12, md: 4 },
          },
          {
            id: "employmentType",
            type: "select",
            col: { cols: 12, md: 4 },
            rules: [VALIDATION.required],
            required: true,
            options: [
              { value: "flexijob" },
              { value: "occasionalWorker" },
              { value: "outsideNormalEmployment" },
              { value: "volunteer" },
              { value: "unpaidActivity" },
              { value: "other" },
            ],
          },
        ],
      },
    ],
  },
];
